import React from 'react';
import { DatePicker } from 'jalali-react-datepicker';
import { pickerDay, pickerValue } from '../../util/date-only';
import './style.css';

export default function DateOnlyPicker({ value, onChange, disabled = false, label }) {
    return <div className="akschap-date-only" inert={disabled ? '' : undefined} style={{ pointerEvents: disabled ? 'none' : undefined, opacity: disabled ? .65 : 1 }}>
        {label && <label>{label}</label>}
        <DatePicker key={value} value={pickerValue(value)} timePicker={false}
            onClickSubmitButton={({ value: selected }) => { const day = pickerDay(selected); if (!disabled && day) onChange(day); }} />
    </div>;
}
